import React from "react";

import { GatsbyImage } from "gatsby-plugin-image";

/**
 * Author profile component
 * @param user user object
 * @returns Returns an author profile component
 */
const AuthorProfile = ({ user }) => {
    return(
        <div className="author-profile">
            <GatsbyImage className="author-profile-image" image={ user?.user_department_information?.customUserProfileImage?.localFile?.childImageSharp?.gatsbyImageData } alt=""/>
            <div className="author-profile-description">
                <h1 className="author-profile-description-title">{ user?.name }</h1>
                <p className="author-profile-description-role">{ user?.user_department_information?.userDepartmentPosition }</p>
                <p className="author-profile-description-content" dangerouslySetInnerHTML={{ __html: user?.description }}></p>
            </div>
        </div>
    )
}

export default AuthorProfile;